import { Star } from "lucide-react";

export const BrandMark = () => (
  <span className="flex flex-col justify-center" data-testid="brand-mark">
    <span className="flex items-center gap-1 mb-1.5">
      <span className="h-[3px] w-5 bg-crimson rounded-full" />
      <span className="h-[3px] w-5 bg-cream rounded-full" />
      <span className="h-[3px] w-5 bg-royal rounded-full" />
      <Star className="w-3 h-3 text-gold fill-gold" />
    </span>
    <span className="font-display font-extrabold uppercase tracking-wide text-cream text-lg sm:text-xl leading-none">
      Dave Graham
    </span>
    <span className="font-mono text-[9px] tracking-[0.3em] uppercase text-gold leading-none mt-1">
      For Attorney General
    </span>
  </span>
);

export default BrandMark;
